import { Box, Button, Grid, Typography } from '@mui/material'
import React from 'react'
import HalfSizeBanner from '../components/Banners/HalfSizeBanner'
import TabComp from '../components/Tabs/TabComp'
import Cards from '../components/Cards/Cards'
import ContentCard from '../components/Cards/ContentCard'
import BigCard from '../components/Cards/BigCard'
import { useTranslation } from '../hook/Translation'

export default function LuxurySignatureFacials() {
const { t } = useTranslation();
    const data = [
        {
            header: 'Face',
            description: 'Lift and sculpt the face without needles using cutting-edge electromagnetic and RF technologies',
            buttonText: 'LEARN MORE',
            buttonUrl: '/'
        },
        {
            header: 'Neck',
            description: 'Lift and sculpt the face without needles using cutting-edge electromagnetic and RF technologies',
            buttonText: 'LEARN MORE',
            buttonUrl: '/'
        },
        {
            header: 'Chest',
            description: 'Lift and sculpt the face without needles using cutting-edge electromagnetic and RF technologies',
            buttonText: 'LEARN MORE',
            buttonUrl: '/'
        }
    ]

    const contectGlowData = {
        imageUrl: '/images/Mask_Group_7.png',
        type: 'Luxury Signature Facials',
        title: 'Brilliant Glow',
        description: 'For broken capillaries, angiomas, rosacea vessels and other red blemishes, we use a specialized vascular laser that targets hemoglobin in the blood. The laser light safely collapses unwanted blood vessels, causing visible redness to fade away over days to weeks.',
        book: '/booknow',
        learn: '/',
    };

    const contectData = {
        imageUrl: '/images/Mask_Group_7.png',
        type: 'Luxury Signature Facials',
        title: 'Absolute Rejuvenation',
        description: 'The ultimate anti-aging facial journey. This comprehensive treatment combines deep cleansing, exfoliation (often a mild peel or microdermabrasion), and intensive hydration with rich peptides. It features lifting massage and may include specialty add-ons like collagen-boosting LED light therapy or microcurrent to tone facial muscles. Finally, a nourishing mask drenches skin in moisture. Benefit: Fine lines and signs of fatigue are softened, skin feels firm and absolutely revitalized.',
        book: '/booknow',
        learn: '/',
    };

    const contectLymphaticData = {
        imageUrl: '/images/Mask_Group_7.png',
        type: 'Luxury Signature Facials',
        title: 'Lymphatic Radiance Boost',
        description: `A detoxifying facial focused on lymphatic drainage to depuff, clarify, and brighten the complexion. Gentle lifting and sweeping massage techniques, supported by sculpting tools such as gua sha, encourage lymph flow to reduce fluid retention, puffiness, and dark under-eye buildup. Light exfoliation and an oxygenating mask help remove surface congestion. Skin is then treated with hydrating essences so you leave looking rested, clear, and lit from within.
Benefit: Reduces puffiness and congestion for a more defined jawline, brighter eye area, and an overall clearer, toned appearance.`,
        book: '/booknow',
        learn: '/',
    };

    const contectUltimateData = {
        imageUrl: '/images/Mask_Group_7.png',
        type: 'Luxury Signature Facials',
        title: 'Ultimate Lift & Sculpt',
        description: 'A high-performance facial for visible contour and firmness. This treatment combines intensive muscle-stimulating massage and, when indicated, targeted microcurrent to help lift and define facial structure. Deep sculpting techniques along the cheekbones, jawline, and neck are paired with firming masks such as algae or collagen to tighten, hydrate, and smooth.',
        book: '/booknow',
        learn: '/',
    };

    const tabData = {
        tabs: ["BRILLIANT GLOW", "ABSOLUTE REJUVENATION", "LYMPHATIC RADIANCE BOOST", "ULTIMATE LIFT & SCULPT"],
        context: [
            (
                <Box marginTop={'85px'}>
                    
                    <Box className='generalContainer' marginX={'auto'}>
                        <ContentCard data={contectGlowData} pair={false} textAlign={'center'} heigth={{ md: 400, xs: 'auto' }} />
                    </Box>

                    <Box className='generalContainer' marginX={'auto'} marginTop={'100px'}>
                        <Cards data={data} imageHeight={'340px'} headerAlign={'center'} descriptionAlign={'center'} buttonAlign={'auto'} sizes={{ xs: 12, sm: 6, md: 6, lg: 4 }} bgColor={'#1E353D'} />
                    </Box>

                    <Box sx={{ width: { md: '65%', xs: '90%' }, marginX: 'auto', marginY: '80px' }}>
                        <Box sx={{ height: { md: 520, xs: 'auto' } }}>
                            <BigCard
                                data={{
                                    // book: '/',
                                    type: 'Technology',
                                    // learn: '/',
                                    title: 'HIFES™',
                                    size: { md: 8, xs: 12 },
                                    btnContainer: { md: 10, xs: 12 },
                                    // imageUrl: "/images/Mask_Group_42.png",
                                    // flexDirection: {md: 'row-reverse', xs: 'row'},
                                    description: 'RF gently heats the dermis to stimulate collagen and elastin production, improving skin firmness and elasticity. At the same time, HIFES™ delivers high-intensity electromagnetic stimulation to facial elevator muscles, increasing tone and lift. In just a 20-minute session, RF firms the skin while HIFES™ enhances muscle support in the forehead, cheeks, and jawline.'
                                }}
                                extraStyle={{
                                    background: 'linear-gradient(90deg,rgba(30, 53, 61, 1) 0%, rgba(30, 53, 61, 1) 35%, rgba(30, 53, 61, 1) 50%, rgba(30, 53, 61, 1) 100%)'
                                }}
                                bgColor={'unset'}
                            />
                        </Box>
                    </Box>
                </Box>
            ),
            (
                <Box marginTop={'50px'}>
                    <Box className='generalContainer' marginX={'auto'}>
                        <ContentCard data={contectData} pair={false} textAlign={'center'} heigth={{ md: 400, xs: 'auto' }} />
                    </Box>
                    <Box className='generalContainer' marginX={'auto'} marginTop={'100px'}>
                        <Grid container spacing={6}>
                            <Grid size={12}>
                                <Grid container spacing={2}>
                                    <Grid size={12}>
                                        <Typography variant="body1" className='dColor' fontWeight={'bold'} fontSize={'1.125rem'} textAlign={'center'}>Treatment Areas</Typography>
                                    </Grid>
                                    <Grid size={12}>
                                        <Typography variant="body1" className='dColor' fontSize={'1rem'} textAlign={'center'}>Full face, and can include neck and chest if desired</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid size={12}>
                                <Cards data={data} imageHeight={'340px'} headerAlign={'center'} descriptionAlign={'center'} buttonAlign={'auto'} sizes={{ xs: 12, sm: 6, md: 6, lg: 4 }} bgColor={'#1E353D'} />
                            </Grid>
                        </Grid>
                    </Box>
                    <Box marginY={'100px'}>
                        <HalfSizeBanner height={{ md: '520px', xs: 'atuo' }}>
                            <Box height={'100%'} bgcolor={'text.secondary'}>
                                <Grid container spacing={12} alignContent={'center'} height={'100%'} marginX={'auto'} sx={{ width: { lg: '80%' } }}>
                                    <Grid size={12}>
                                        <Grid container spacing={4} paddingY={{ md: 'unset', xs: '1.12rem' }}>
                                            <Grid size={12}>
                                                <Typography gutterBottom variant="body1" className='wColor' fontSize={{ md: '1.125rem', xs: '1rem' }}>
                                                    Pairing
                                                </Typography>
                                                <Typography variant="h3" className='wColor' fontFamily={'DanmarkURW'} fontSize={{
                                                    md: '2.875rem',
                                                    xs: '1.875rem'
                                                }}>Pigmentation Spot Laser</Typography>
                                            </Grid>
                                            <Grid size={5}>
                                                <Typography variant="body1" className='wColor' fontSize={{ md: '1rem', xs: '1rem' }}>
                                                    Pairs well with: our Emface or RF Tightening sessions do the tech treatment first to stimulate from within, then follow with Absolute Rejuvenation facial to soothe, hydrate, and amplify the youthful effects.
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid size={5}>
                                        <Grid container spacing={4}>
                                            {/* <Grid size={6}>
                                                <Button variant='contained'
                                                    className='borderRadiusFlat borderWidth2 buttonPaddingY10 placeBorder whiteBorderColor noShadow'
                                                    fullWidth>BOOK NOW</Button>
                                            </Grid> */}
                                            <Grid size={6}>
                                                <Button variant='contained' sx={{ backgroundColor: 'text.secondary', color: '#FFF' }}
                                                    className='borderRadiusFlat borderWidth2 buttonPaddingY10 placeBorder whiteBorderColor noShadow'
                                                    fullWidth>LEARN MORE</Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Box>
                        </HalfSizeBanner>
                    </Box>
                </Box>
            ),
            (
                <Box marginTop={'50px'}>
                    <Box className='generalContainer' marginX={'auto'}>
                        <ContentCard data={contectLymphaticData} pair={false} textAlign={'center'} heigth={{ md: 400, xs: 'auto' }} />
                    </Box>
                    <Box className='generalContainer' marginX={'auto'} marginTop={'100px'}>
                        <Cards data={data} imageHeight={'340px'} headerAlign={'center'} descriptionAlign={'center'} buttonAlign={'auto'} sizes={{ xs: 12, sm: 6, md: 6, lg: 4 }} bgColor={'#1E353D'} />
                    </Box>
                    <Box marginY={'100px'}>
                        <HalfSizeBanner height={{ md: '520px', xs: 'atuo' }}>
                            <Box height={'100%'} bgcolor={'text.secondary'}>
                                <Grid container spacing={12} alignContent={'center'} height={'100%'} marginX={'auto'} sx={{ width: { lg: '80%' } }}>
                                    <Grid size={12}>
                                        <Grid container spacing={4} paddingY={{ md: 'unset', xs: '1.12rem' }}>
                                            <Grid size={12}>
                                                <Typography gutterBottom variant="body1" className='wColor' fontSize={{ md: '1.125rem', xs: '1rem' }}>
                                                    Pairing
                                                </Typography>
                                                <Typography variant="h3" className='wColor' fontFamily={'DanmarkURW'} fontSize={{
                                                    md: '2.875rem',
                                                    xs: '1.875rem'
                                                }}>Pigmentation Spot Laser</Typography>
                                            </Grid>
                                            <Grid size={5}>
                                                <Typography variant="body1" className='wColor' fontSize={{ md: '1rem', xs: '1rem' }}>
                                                    treatment you might zap a few sunspots with laser, then pamper the whole face with Brilliant Glow for an
                                                    all-over radiance.
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid size={5}>
                                        <Grid container spacing={4}>
                                            {/* <Grid size={6}>
                                                <Button variant='contained'
                                                    className='borderRadiusFlat borderWidth2 buttonPaddingY10 placeBorder whiteBorderColor noShadow'
                                                    fullWidth>BOOK NOW</Button>
                                            </Grid> */}
                                            <Grid size={6}>
                                                <Button variant='contained' sx={{ backgroundColor: 'text.secondary', color: '#FFF' }}
                                                    className='borderRadiusFlat borderWidth2 buttonPaddingY10 placeBorder whiteBorderColor noShadow'
                                                    fullWidth>LEARN MORE</Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Box>
                        </HalfSizeBanner>
                    </Box>
                </Box>
            ),
            (
                <Box marginTop={'50px'}>
                    <Box className='generalContainer' marginX={'auto'}>
                        <ContentCard data={contectUltimateData} pair={false} textAlign={'center'} heigth={{ md: '400px', xs: 'auto' }} />
                    </Box>
                    <Box className='generalContainer' marginX={'auto'} marginTop={'100px'}>
                        <Cards data={data} imageHeight={'340px'} headerAlign={'center'} descriptionAlign={'center'} buttonAlign={'auto'} sizes={{ xs: 12, sm: 6, md: 6, lg: 4 }} bgColor={'#1E353D'} />
                    </Box>
                    <Box marginY={'100px'}>
                        <HalfSizeBanner height={{ md: '520px', xs: 'atuo' }}>
                            <Box height={'100%'} bgcolor={'text.secondary'}>
                                <Grid container spacing={12} alignContent={'center'} height={'100%'} marginX={'auto'} sx={{ width: { lg: '80%' } }}>
                                    <Grid size={12}>
                                        <Grid container spacing={4} paddingY={{ md: 'unset', xs: '1.12rem' }}>
                                            <Grid size={12}>
                                                <Typography gutterBottom variant="body1" className='wColor' fontSize={{ md: '1.125rem', xs: '1rem' }}>
                                                    Pairing
                                                </Typography>
                                                <Typography variant="h3" className='wColor' fontFamily={'DanmarkURW'} fontSize={{
                                                    md: '2.875rem',
                                                    xs: '1.875rem'
                                                }}>Pigmentation Spot Laser</Typography>
                                            </Grid>
                                            <Grid size={5}>
                                                <Typography variant="body1" className='wColor' fontSize={{ md: '1rem', xs: '1rem' }}>
                                                    Emface, for layered lift. Emface builds muscle tone and collagen over the course of a series, and Ultimate Lift & Sculpt maintains that definition between sessions while nourishing the skin.
                                                    <br />
                                                    Also pairs well with Needle Free RF Tightening. RF firms the skin from within by stimulating collagen, and Ultimate Lift & Sculpt adds external muscle contouring, lymphatic refinement, and hydration.                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid size={5}>
                                        <Grid container spacing={4}>
                                            {/* <Grid size={6}>
                                                <Button variant='contained'
                                                    className='borderRadiusFlat borderWidth2 buttonPaddingY10 placeBorder whiteBorderColor noShadow'
                                                    fullWidth>BOOK NOW</Button>
                                            </Grid> */}
                                            <Grid size={6}>
                                                <Button variant='contained' sx={{ backgroundColor: 'text.secondary', color: '#FFF' }}
                                                    className='borderRadiusFlat borderWidth2 buttonPaddingY10 placeBorder whiteBorderColor noShadow'
                                                    fullWidth>LEARN MORE</Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Box>
                        </HalfSizeBanner>
                    </Box>
                </Box>
            )
        ]
    };

    return (
        <Box>
            <Box>
                <HalfSizeBanner height={{ md: '460px', xs: 'atuo' }}>
                    <Box height={'100%'} bgcolor={'text.secondary'}>
                        <Grid container alignItems={'center'} className='generalContainer' height={'100%'} marginX={'auto'}>
                            <Grid size={{ md: 7, xs: 12 }}>
                                <Grid container spacing={4} paddingY={{ md: 'unset', xs: '1.12rem' }}>
                                    <Grid size={12}>
                                        <Typography variant="h3" className='wColor' fontFamily={'DanmarkURW'} fontSize={{ md: '2.875rem', xs: '1.875rem' }}>Luxury Signature Facials</Typography>
                                    </Grid>
                                    <Grid size={12}>
                                        <Typography variant="body1" className='wColor' fontSize={{ md: '1.125rem', xs: '1rem' }}>
                                            Luxury meets the results of our most pampering facials. These indulgent, hands-on treatments blend relaxation with advanced skincare, each with its own focus to address your skin’s needs while offering a premium spa experience.
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </HalfSizeBanner>
            </Box>
            <Box>
                <TabComp tabContext={tabData} paddingTop={{md: '63px'}} />
            </Box>
            <Box className='generalContainer' marginX={'auto'} marginBottom={{md: '90px', xs: ''}} marginTop={{md: '114px', xs: ''}}>
                <Typography variant="body1" className='dColor' textAlign={'center'} fontSize={'30px'} fontWeight={'600'}>
                    Each of our luxury facials is a 60-90 minute escape that marries clinical-grade products with the healing touch of our expert therapists. Pairing note: You can certainly combine a facial with other services on the same day many clients, for example, enjoy a Japanese Head Ritual or a Hand Massage add-on during their facial, truly head-to-toe indulgence in one visit.
                </Typography>
            </Box>
        </Box>
    )
}